import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Utils         from 'utils';
import Sanitize      from '@utils/sanitize';

import Card          from '@common/influencer/_card';

import { Fade } from 'react-slideshow-image';

import 'react-slideshow-image/dist/styles.css'
import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------


class PostPreview extends React.Component {
  render() {
    let detail = this.props.detail;
    
    let media     = detail.media;
    let caption   = detail.caption;
    let score     = detail.score;
    let post_date = detail.post_date;
    
    let thumbnail = '';
    try { thumbnail = media[0].media_url; } catch(e) {}
    
    // キャプション
    let _caption = null;
    try { if( caption != undefined && caption != null ) _caption = Sanitize.nl2br(caption); } catch(e) {}
    
    // スコアリスト
    let scoreList = [
      { id: 'likes', name: 'いいね数' }, { id: 'comments', name: 'コメント数' }, { id: 'saved', name: '保存数' },
      { id: 'impressions', name: 'インプレッション' }, { id: 'reach', name: 'リーチ数' }
    ];
    
    if( detail.product_type == 'REELS' ){
      scoreList = [
        { id: 'likes', name: 'いいね数' }, { id: 'comments', name: 'コメント数' }, { id: 'saved', name: '保存数' },
        { id: 'plays', name: '再生数' }, { id: 'impressions', name: 'インプレッション' }, { id: 'reach', name: 'リーチ数' }
      ];
    }
    
    if( detail.product_type == 'STORY' ){
      scoreList = [
        { id: 'impressions', name: 'インプレッション' }, { id: 'reach', name: 'リーチ数' }
      ];
    }
    
    if( thumbnail == '' ){
      if( this.props.is_loading == true ){
        return null;
      } else {
        return <div>メディアが見つかりません</div>;
      }
    } else {
      return (
        <div className="modal-item main-image">
          <div className="left-thumbnail">
            { (media.length <= 1)
              ? <div className="image-single">
                  {(thumbnail != null && thumbnail.indexOf('.jpg') !== -1) ? <img src={thumbnail} /> : null }
                  {(thumbnail != null && thumbnail.indexOf('.png') !== -1) ? <img src={thumbnail} /> : null }
                  {(thumbnail != null && Utils.isVideo(thumbnail)) ? <video controls src={thumbnail} /> : null }
                </div>
              : <Fade autoplay={false} indicators={true} transitionDuration={100}>
                  { media.map((d, key) => {
                    return(
                      <div className="each-slide" key={key}>
                        {(d.media_url.indexOf('.jpg') !== -1) ? <img src={d.media_url} /> : null }
                        {(d.media_url.indexOf('.png') !== -1) ? <img src={d.media_url} /> : null }
                        {(Utils.isVideo(d.media_url)) ? <video controls src={d.media_url} /> : null }
                      </div>
                    );
                  })}
                </Fade>
            }
            
            <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>投稿のURLに飛ぶ</Tooltip>}>
              <a href={'https://www.instagram.com/p/'+ detail.shortcode} className="media-link" target="_blank"><i className="material-icons">link</i></a>
            </OverlayTrigger>
            
            <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>メディアを保存</Tooltip>}>
              <a href={thumbnail} className="image-download" download><i className="material-icons">download</i></a>
            </OverlayTrigger>
          </div>
          <div className="right-caption">
            { (post_date != undefined) && <div className="post-date">{Utils.setDate(post_date, 'YYYY/M/D HH:mm')}</div> }
            <div className="caption" dangerouslySetInnerHTML={{ __html: _caption }} />
            
            { (score != undefined ) &&
              <div className="score">
                { scoreList.map((d, key) => {
                  let value = score[d.id];
                  value = ( value == null ) ? '-' : Utils.viewInt(value);
                  
                  return (
                    <div key={key} className="score-item">
                      <h6>{d.name}</h6>
                      <h3>{value}</h3>
                    </div>
                  );
                })}
              </div>
            }
            
            { (detail.account != undefined && Object.keys(detail.account).length > 0 ) &&
              <Card data={detail.account} base={this.props.base} />
            }
          </div>
        </div>
      );
    }
  }
}
// -------------------------------------------------------

// レンダリング処理
export default PostPreview;